import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  finalSaleReturnFromModel,
  validateFinalSaleReturnCondition,
  type FinalSaleReturnState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const FINAL_SALE_RETURN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<FinalSaleReturnState>>,
): ConditionType<FinalSaleReturnState, Condition.FinalSaleReturn> => ({
  name: CONDITION_NAMES[Condition.FINAL_SALE_RETURN],
  description(state) {
    return t("Item is a final sale return");
  },
  Details(props: ConditionTypeDetailsProps<FinalSaleReturnState>) {
    return React.createElement(Details, props);
  },
  empty: { validCollections: [], validProductTags: [] },
  fromModel(model) {
    return finalSaleReturnFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.FINAL_SALE_RETURN,
      validCollections: state.validCollections,
      validProductTags: state.validProductTags,
    };
  },
  valid(state) {
    return validateFinalSaleReturnCondition(state).valid;
  },
});
